import _ from 'lodash';
import Backbone from 'backbone';

import ErrorView from '@/views/ErrorView/ErrorView';
import Scaffold from '@/Scaffold';
import GetAllRegions from '@/services/GetAllRegions';
import GetAllRegionGroups from '@/services/GetAllRegionGroups';
import { userHasRole } from '@/util/RoleUtils';

import UserAccessView from '../views/UserAccessView/UserAccessView';
import GetAllGroupedRegions from '../services/GetAllGroupedRegions';
import GetAllInternalUserTypes from '../services/GetAllInternalUserTypes';

export default async function loadUserAccessView() {
  if (!userHasRole('Admin')) {
    showErrorView({ message: 'Unauthorized' });
    return;
  }

  try {
    const [regionsUnsorted, regionGroups, groupedRegions, roles] = await Promise.all([
      GetAllRegions(),
      GetAllRegionGroups(),
      GetAllGroupedRegions(),
      GetAllInternalUserTypes()
    ]);

    const regions = sortRegionsByName(regionsUnsorted);
    mapGroupedRegionsToRegionGroups(regionGroups, groupedRegions);

    return new UserAccessView({
      model: new Backbone.Model({
        regions,
        regionGroups,
        roles
      })
    });
  } catch (err) {
    Scaffold.getRegion('content').show(
      new ErrorView({
        model: new Backbone.Model({
          errorMessage: _.isString(err.message) ? err.message : 'An Error Occurred',
          errorDetails: 'Something went wrong while loading the User Access page.'
        })
      })
    );
  }
}

function showErrorView(err) {
  Scaffold.getRegion('content').show(
    new ErrorView({
      model: new Backbone.Model({
        errorMessage: _.isString(err?.message) ? err?.message : 'Access Denied',
        errorDetails: 'Your account may not have permission to view the User Access page.'
      })
    })
  );
}

function sortRegionsByName(regions) {
  return _.sortBy(regions, 'name');
}

function mapGroupedRegionsToRegionGroups(regionGroups, groupedRegions) {
  _.each(regionGroups, (group) => {
    const regions = getGroupedRegionsByRegionGroupId(group.id, groupedRegions);
    const regionIds = mapRegionObjsToRegionIds(regions);
    group.regionIds = regionIds;
  });
}

function getGroupedRegionsByRegionGroupId(regionGroupId, groupedRegions) {
  return _.filter(groupedRegions, (gr) => gr.regionGroupId === regionGroupId);
}

function mapRegionObjsToRegionIds(regions) {
  return _.map(regions, (region) => region.regionId);
}
